import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";
import { Icon } from "@sportal/cdk";

import { usePauseInternet } from "../../pauseInternet/PauseInternetProvider";
import {
  PauseInternetOptions,
  useUnpauseCallback,
} from "../../pauseInternet/PauseInternet";
import { Button } from "../../button/Button";
import { PausedInternetTimeLeft } from "../../pauseInternet/PausedInternetTimeLeft";
import { PauseInternetLabel } from "../../pauseInternet/PauseInternetLabel";

import "./ProfileDetailsPauseInternet.scss";

const label = <FormattedMessage id="internet_pause_settings" />;

export const ProfileDetailsPauseInternet = ({ profileName }) => {
  const { isInternetPaused, timeLeft, pauseInternet, pauseInternetOptions } =
    usePauseInternet();

  const onUnpause = useUnpauseCallback(profileName);
  const isPaused = isInternetPaused && timeLeft;

  return (
    <div
      className={classnames("profile-details-pause-internet", {
        "profile-details-pause-internet--paused": isPaused,
      })}
    >
      {isPaused ? (
        <Fragment>
          <PauseInternetLabel>{label}</PauseInternetLabel>

          <Button
            size="medium"
            iconRight={<Icon icon="fa-regular fa-times" />}
            color="danger"
            onClick={onUnpause}
            ellipsis={false}
          >
            <PausedInternetTimeLeft />
          </Button>
        </Fragment>
      ) : (
        <PauseInternetOptions
          onPauseInternet={pauseInternet}
          options={pauseInternetOptions}
          variant="inverted"
          label={label}
          size="medium"
        />
      )}
    </div>
  );
};
